import { FC, ReactElement } from "react";
import { ColorTone, IconSize } from "@enxcs/dap-ui-stratos/build/foundations/design";
import { IconRoot } from "./Icon.styles";

/*
 * NOTE: The icon component is designed to be only a graphic element.
 * No extra props should be added to the following interface.
 * All the UI behaviours should be handled wrapping the icon with another element (e.g. Button).
 */

export interface IconProps {
  children: ReactElement | ReactElement[];
  size: IconSize;
  tone?: ColorTone;
  className?: string;
  viewBox?: string;
}

const Icon: FC<IconProps> = ({ children, size, tone, className, viewBox = "0 0 24 24" }) => (
  <IconRoot
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    fill="none"
    $size={size}
    $tone={tone}
    className={className}
    aria-hidden="true"
  >
    {children}
  </IconRoot>
);

export default Icon;
export type IconComponent = FC<Omit<IconProps, "children">>;
